import { Auth } from '@aws-amplify/auth';
import { handleResponse, handleError } from './api-utils';
import { apiConstants } from './api-constants';

export function getSSOSignInFormData() {
    return fetch(apiConstants.loadSignInFormDataUrl)
        .then(handleResponse)
        .catch(handleError);
}

export function getSSOSignInSuccessFormData() {
    return fetch(`${window.location.origin}${apiConstants.signInSuccessFromDataUrl}`)
        .then(handleResponse)
        .catch(handleError);
}

export function getNewPasswordRequiredFormData() {
    return fetch(apiConstants.loadNewPasswordRequiredFormDataUrl)
        .then(handleResponse)
        .catch(handleError);
}

export function completeNewPassword({ cognitoUser, password }) {
    return Auth.completeNewPassword(cognitoUser, password);
}

export function signInUser(userSignInData) {
    return Auth.signIn(userSignInData.username, userSignInData.password);
}

export function signOutUser() {
    return Auth.signOut();
}

export function updateUserSignInDetails(userDetails, callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify(userDetails)
        })
            .then(handleResponse)
            .catch(handleError);
    });
}
